import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isUndergroundMapV2 } from '../../utils/isUndergroundMapV2';
import { requestFonts } from '../requestFonts';
var undergroundMapDataCache = new Map();
export function requestUndergroundMapData(_x, _x2) {
  return _requestUndergroundMapData.apply(this, arguments);
}

function _requestUndergroundMapData() {
  _requestUndergroundMapData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(locationId, onDataRequested) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            data = undergroundMapDataCache.get(locationId);

            if (data) {
              _context.next = 6;
              break;
            }

            _context.next = 4;
            return onDataRequested(locationId);

          case 4:
            data = _context.sent;
            undergroundMapDataCache.set(locationId, data);

          case 6:
            if (!isUndergroundMapV2(data)) {
              requestFonts();
            }

            return _context.abrupt("return", data);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _requestUndergroundMapData.apply(this, arguments);
}